<template>
  <div class="hosting">
    <NavComponent></NavComponent>
    <div
      class="banner"
      v-bind:style="{ backgroundImage: 'url(' + banner + ')' }"
    ></div>
    <main>
      <div class="content-container main">
        <div class="hosting-top">
          <div class="top-left">
            <Swiper
              class="swiper-container"
              :options="swiperOption"
              ref="swiperTop"
            >
              <Swiper-slide
                class="slid-container"
                v-for="(slideItem, index) in houseDetail.picture"
                :key="index"
              >
                <div
                  class="slide"
                  v-bind:style="{
                    backgroundImage: 'url(' + slideItem + ')',
                  }"
                ></div>
                <!-- <img class="slide" :src="slideItem.image" /> -->
              </Swiper-slide>
            </Swiper>
          </div>
          <div class="mini-swiper">
            <div class="row-top" @click="swiperPrev()"><img :src="top_row" /></div>
            <Swiper
              class="swiper gallery-thumbs"
              :options="swiperOptionThumbs"
              ref="swiperThumbs"
            >
              <Swiper-slide
                class="slid-container"
                v-for="(slideItem, index) in houseDetail.picture"
                :key="index"
              >
                <div
                  class="slide-thumbs"
                  v-bind:style="{
                    backgroundImage: 'url(' + slideItem + ')',
                  }"
                ></div>
                <!-- <img class="slide-thumbs" :src="slideItem.image" /> -->
              </Swiper-slide>
            </Swiper>
            <div class="row-top row-bottom" @click="swiperNext()"><img :src="bottom_row" /></div>
          </div>
          <div class="top-right">
            <div class="title">{{houseDetail.title}}</div>
            <!-- <p>国家：<span>{{}}</span></p> -->
            <div class="house-method">
              <div v-for="(item,index) in houseDetail.method" class="method-item" :key="index">{{item}}</div>
            </div>
            <div v-if="houseDetail.min" class="row">
              <p class="price">总价：<span>￡ </span><span class="row-price-all">{{houseDetail.min}}</span><span> 万起</span></p>
              <p class="price"><span>￥ </span><span class="row-price-all">{{houseDetail.rmb_min}}</span><span> 万起</span></p>
            </div>
            <div v-if="houseDetail.price" class="row">
              <p class="price">单价：<span class="row-price">￡{{houseDetail.price}}/㎡</span></p>
              <p class="price">￥ <span class="row-price">{{houseDetail.rmb_price}}/㎡</span></p>
            </div>
            <div class="row-line"></div>
            <div class="row">
              <p class="top-row-left" v-if="houseDetail.city">城市：<span>{{houseDetail.city}}</span></p>
              <p class="top-row-right" v-if="houseDetail.type">房产类型：<span>{{houseDetail.type}}</span></p>
            </div>
            <div class="row">
              <p class="top-row-left" v-if="houseDetail.layoutdesc">户型：<span>{{houseDetail.layoutdesc}}</span></p>
              <p class="top-row-right" v-if="houseDetail.housetype">现/期房：<span>{{houseDetail.housetype}}</span></p>
            </div>
            <div class="row">
              <p class="top-row-left" v-if="houseDetail.completed_time">竣工时间：<span>{{houseDetail.completed_time}}</span></p>
              <p class="top-row-right" v-if="houseDetail.built_area">面积：<span>{{houseDetail.built_area}}</span></p>
            </div>
            <div class="row">
              <p class="top-row-left" v-if="houseDetail.floor">层高：<span>{{houseDetail.floor}}</span></p>
              <p class="top-row-right" v-if="houseDetail.duration">产权：<span>{{houseDetail.duration}}</span></p>
            </div>
            <p v-if="houseDetail.developer">开发商：<span>{{houseDetail.developer}}</span></p>
            <p v-if="houseDetail.address">地址：<span>{{houseDetail.address}}</span></p>
          </div>
        </div>
        <div class="tab">
          <div v-for="(item, index) in tabList" :key="index">
            <div
              :class="[active == index ? 'tab-name active' : 'tab-name']"
              @click="change(index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <ul ref="item">
          <li>
            <h4><img style="width:1.3rem;height:1.3rem;" :src="huxing" />户型推荐</h4>
            <div class="house-type">
              <!-- <Loading v-if="loading"></Loading> -->
              <div class="row-left"  @click="scrollLeft()"><img :src="top_row" /></div>
              <Swiper
                class="swiper swiper-scroll"
                :options="swiperScroll"
                ref="swiperScroll"
              >
              <Swiper-slide v-for="(item,index) in houseDetail.layout" :key="index">
                <!-- <img class="type-img" :src="item" /> -->
                <el-image class="type-img" @click="openBigImage(index)" fit="contain"  :src="item" ></el-image>
              </Swiper-slide>
              </Swiper>
              <div class="row-left row-right" @click="scrollRight()"><img :src="top_row" /></div>
            </div>
          </li>
          <li v-if="houseDetail.url">
            <h4><img style="width:1.5rem;height:1rem;" :src="video_icon" />视频展示</h4>
            <div class="video" @click="openVideo()" v-bind:style="{backgroundImage: 'url('+houseDetail.image+')',}" >
              <img style="width:3.2rem;height:3.2rem;" :src="shipin_icon" />
            </div>
          </li>
          <li>
            <h4><img style="width:1.2rem;height:1.5em;" :src="dizhi_icon" />地理位置</h4>
            <div id="map" class="map"></div>
          </li>
          <li>
            <h4><img style="width:1.6rem;height:1.6em;" :src="loufang_icon" />项目介绍</h4>
            <p class="loufang" v-html="houseDetail.conditions"></p>
          </li>
          <li>
            <h4><img style="width:1.6rem;height:1.6em;" :src="dingwei_icon" />周边详情</h4>
            <p class="loufang" v-html="houseDetail.overview"></p>
          </li>
          <!-- <li v-if="houseDetail.url">
            <h4>【视频展示】</h4> -->
            <!-- <div class="item-name">购房费用</div>
            <div class="cost">
              <div class="row">
                <div><span>律师费：</span><b>{{houseDetail.lawyer_fee}}</b></div>
                <div><span>印花税：</span><b>{{houseDetail.stamp_tax}}</b></div>
              </div>
              <div><span>服务费：</span><b>{{houseDetail.service_fee}}</b></div>
            </div>
            <div class="item-name">持有费用</div>
            <div class="cost">
              <div class="row">
                <div><span>市政税：</span><b>{{houseDetail.council_tax}}</b></div>
                <div><span>地租费：</span><b>{{houseDetail.land_rent}}</b></div>
              </div>
              <div><span>物业费：</span><b>{{houseDetail.property_fee}}</b></div>
            </div>
            <div class="item-name">租赁托管费用</div>
            <div class="cost">
              <div><b>{{houseDetail.trusteeship_fee}}</b></div>
            </div> -->
          <!-- </li> -->
          <li>
            <h4><img style="width:1.5rem;height:1.4em;" :src="liucheng_icon" />购房流程</h4>
            <div class="box-img">
              <img class="step-img" :src="step_img" />
            </div>
          </li>
        </ul>
      </div>
    </main>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="viewerImgList" />
    <VideoComponent  v-if="videoShow" :videoUrl="houseDetail.url" ></VideoComponent>
    <SideBarComponent></SideBarComponent>
    <FooterComponent></FooterComponent>
  </div>
</template>
<script>
import FooterComponent from "@components/FooterComponent";
import NavComponent from "@components/NavComponent";
import SideBarComponent from "@components/SideBarComponent";
import VideoComponent from "@components/VideoComponent"

import banner from "@assets/image/hosting/hosting_banner.jpg";
import step_img from "@assets/image/hosting/step-img.jpg";
import shipin_icon from '@assets/image/hosting/shipin-icon.png';
import video_icon from '@assets/image/hosting/video-icon.png';
import dizhi_icon from '@assets/image/hosting/dizhi-icon.png';
import loufang_icon from '@assets/image/hosting/loufang-icon.png';
import huxing from '@assets/image/hosting/huxing.png';
import dingwei_icon from '@assets/image/hosting/dingwei-icon.png';
import top_row from "@assets/image/hosting/top-row-icon.png";
import liucheng_icon from '@assets/image/hosting/liucheng-icon.png';
import bottom_row from "@assets/image/hosting/bottom-row-icon.png";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import mapboxgl from "mapbox-gl";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue'
export default {
  name: "HouseHostingPage",
  computed: {

  },
  components: {
    FooterComponent,
    NavComponent,
    SideBarComponent,
    VideoComponent,
    Swiper,
    SwiperSlide,
    ElImageViewer
  },
  data() {
    return {
      banner,
      tabList: [
        { name: "户型推荐",show:true },
        { name: "视频",show:true },
        { name: "地理位置",show:true },
        { name: "项目介绍",show:true },
        { name: "周边详情",show:true },
        { name: "购房流程",show:true },
      ],
      active: 0,
      videoShow:false,
      step_img,shipin_icon,
      top_row,huxing,
      video_icon,dizhi_icon,loufang_icon,dingwei_icon,liucheng_icon,
      bottom_row,
      houseId:null,
      loading:false,
      showViewer:false,
      method:'',
      houseDetail:{},
      viewerImgList:[],
      swiperOption: {
        loop: true,
        loopedSlides: 4,
        spaceBetween: 10,
        autoplay: {
          //自动播放
          delay: 3000,
          disableOnInteraction: false,
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 4, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        // autoplay: {
        //   delay: 3000,
        // },
        direction: "vertical",
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      swiperScroll:{
        slidesPerView : "auto",
        slidesPerGroup : 4,
        loopedSlides: 4,
        spaceBetween: 10,
      }
    };
  },
  created() {
    this.houseId = this.$route.path.split("/").slice(-1)[0]
    this.getHouseDetail()
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods: {
    change(index) {
      this.active = index;
      window.scrollTo({
        behavior: "smooth",
        top: this.$refs.item.children[index].offsetTop,
      });
    },
    setMap(){
      let center = [this.houseDetail.longitude,this.houseDetail.latitude]
      let that = this
      mapboxgl.accessToken =
      "pk.eyJ1IjoidXppbGl2aW5nIiwiYSI6ImNqemhzbmdxMTB5Y3MzZHBpazN1N3d2cTkifQ.3-_OtVv-450QSH1sNu2mGA";
      var map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/streets-v11?optimize=true",
        center: center,
        pitch: 60,
        bearing: -60,
        zoom: 16,
      });
      new mapboxgl.Popup({ closeButton:false,offset: 25})
        .setLngLat(center)
        .setHTML('<h1>'+that.houseDetail.title+'</h1>')
        .addTo(map);
      new mapboxgl.Marker().setLngLat(center).addTo(map);
    },
    getHouseDetail(){
      var that = this
      this.loading = true
      this.axios.get(this.url+'/api/web/loupan/info',{params:{'id':this.houseId/1}}).then(function(response){
        that.houseDetail = response.data.data;
        var arr = [];
        !!response.data.data.layout && arr.push(that.tabList[0]);
        !!response.data.data.url && arr.push(that.tabList[1]);
        !!response.data.data.longitude && arr.push(that.tabList[2]);
        !!response.data.data.conditions && arr.push(that.tabList[3]);
        !!response.data.data.overview && arr.push(that.tabList[4]);
        arr.push(that.tabList[5])
        // that.loading = false
        that.tabList = arr
        that.method = response.data.data.method[0]
        that.setMap()
      }).catch(function() {
        that.loading = false
      });
    },
    swiperNext(){
      this.$refs.swiperTop.$swiper.slideNext()
    },
    swiperPrev(){
      this.$refs.swiperTop.$swiper.slidePrev()
    },
    openVideo(){
      this.videoShow = true;
    },
    colseVideo(){
      this.videoShow = false
    },
    scrollLeft(){
      this.$refs.swiperScroll.$swiper.slidePrev()
    },
    scrollRight(){
      this.$refs.swiperScroll.$swiper.slideNext()
    },
    openBigImage(index){
      this.showViewer = true;
      let tempImgList = [...this.houseDetail.layout];
      let temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempImgList.shift());
      }
      this.viewerImgList = tempImgList.concat(temp);
    },
    closeViewer(){
      this.showViewer = false
    }
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 21rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
main {
  background: #f3f3f3;
  padding: 4.2rem 0 5rem 0;
  .main {
    width: 62rem;
    height: auto;
  }
  .hosting-top {
    display: flex;
    align-items: center;
    padding: 0.8rem;
    background: #fff;
    margin-bottom: 2.5rem;
  }
  .row-top {
    background-color: #8a8e91;
    width: 6rem;
    height: 0.8rem;
    margin-left: 0.6rem;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      width: 0.8rem;
      height: 0.4rem;
    }
  }
  .top-left {
    width: 31rem;
    height: 21rem;
    position: relative;
    overflow: hidden;
  }
  .top-right {
    min-width: 19rem;
    .title {
      color: #0e2d57;
      font-size: 1.5rem;
      font-weight: 700;
      margin: 1rem 0 0.4rem;
    }
    .row{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .row-line{
      width: 100%;
      height: 2px;
      margin:0.6rem 0;
      background-color: #cbac72;
    }
    .price{
      padding-right: 2rem;
      flex:0.5;
      span{
        color: #a22915;
      }
      .row-price-all{
        font-weight: bold;
        font-size: 1.2rem;
      }
      .row-price{
        color: #0e2d57;
        font-weight: bold;
        font-size: 0.8rem;
      }
    }
    p {
      font-size: 0.8rem;
      color: $font;
      line-height: 1.8rem;
    }
  }
  .house-method{
    display: flex;
    flex-wrap: wrap;
    .method-item{
      color: #a18760;
      padding: 0.1rem 0.8rem;
      font-size: 0.7rem;
      background-color: #f8f4ed;
      border-radius: 0.8rem;
      border: 1px solid #a18760;
      margin-bottom: 0.4rem;
    }
    .method-item:not(:last-child){
      margin-right: 0.4rem;
    }
  }
  .top-row-left{
    flex:0.6;
  }
  .top-row-right{
    flex:0.4;
  }
  .gallery-top {
    height: 80%;
    width: 100%;
  }
  .gallery-thumbs {
    width: 6rem;
    height: 20rem;
    box-sizing: border-box;
    margin: 0 1.6rem 0 0.6rem;
    // padding: $gap 0;
  }
  .gallery-thumbs .swiper-slide {
    width: 6rem;
    height: 4rem;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }
  .slide {
    width: 31rem;
    height: 21rem;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .slide-thumbs {
    width: 6rem;
    height: 4rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    box-sizing: content-box;
  }
  .slide-thumbs:not(:last-child) {
    margin-bottom: 0.4rem;
  }
  .tab {
    background: #fff;
    display: flex;
    padding: 1.25rem 0 1.25rem 2.4rem;
    border-bottom: solid 1px #f3f3f3;
    .tab-name {
      padding: 0 2rem;
      line-height: 2rem;
      font-size: 0.9rem;
      color: #818181;
      cursor: pointer;
    }
    .active {
      background-color: #a22915;
      border-radius: 1rem;
      color: #fff;
    }
  }
  ul {
    background: #fff;
    padding: 0 2.4rem 5rem 2.4rem;
    li {
      color: #0e2d57;
      .cost{
        width: 30rem;
        margin-left: 1.2rem;
        b{
          color: $font;
        }
      }
      .cost:not(:last-child){
        margin-bottom: 0.8rem;
      }
      .row{
        line-height: 1.8rem;
        display: flex;
        justify-content: space-between;
      }
      h4 {
        padding: 2.5rem 0 1.5rem 0;
        font-weight: 700;
        display: flex;
        align-items: center;
        img{
          margin-right: 1rem;
        }
      }
      p {
        color: $font;
        margin-left: 0.6rem;
      }
      .box-img{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .step-img {
        width: 42rem;
        height: 16rem;
        margin:0 auto;
      }
      .item-name {
        color: #a22915;
        margin-left: 0.6rem;
        margin-bottom: 0.8rem;
      }
      .video{
        width: 15rem;
        height: 8.2rem;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .house-type{
        width: 100%;
        height: 8.5rem;
        display: flex;
        overflow: hidden;
        overflow-x: scroll;
        cursor: pointer;
        &::-webkit-scrollbar{
          background-color:transparent;
        }
        .swiper-scroll{
          width: auto;
        }
        .swiper-scroll .swiper-slide{
          width: 14rem;
          height: 8.5rem;
        }
        .row-left{
          width: 1.1rem;
          height: 8.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #dedede;
          img{
            width: 1rem;
            margin-bottom: 0.8rem;
            -moz-transform:rotate(-90deg);
            -webkit-transform:rotate(-90deg);
          }
        }
        .row-right{
          img{
            -moz-transform:rotate(90deg);
            -webkit-transform:rotate(90deg);
          }
        }
        .type-img{
          width: 14rem;
          height: 8.5rem;
          display: block;
        }
      }
    }
  }
}
.map{
  width: 100%; 
  height: 30rem;
}
@media only screen and (max-width: 1024px){
  .banner{
    height: 12rem;
    background-size: cover;
  }
  main{
    padding: 2.4rem 0 4rem;
    .slide{
      width: 100%;
      margin: 0 auto;
    }
    .top-left{
      width: 100%;
    }
    .main{
      width: 94%;
      margin: 0 auto;
    .hosting-top{
      display: block;
    }
    .mini-swiper{
      display: none;
    }
      ul{
        padding:0rem 1rem 5rem 1rem;
        li{
          .step-img{
            width: 100%;
            height: auto;
          }
        }
      }
    }
    .tab{
      display: none;
    }
  }
  .map{
    height: 18rem;
  }
}
</style>
<style lang="scss">
.loufang img{
  max-width: 750px !important;
  height: auto !important;
  display: block !important;
  margin: 20px auto !important;
}
</style>